import {
  Button,
  Card,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  CardContent,
  Typography,
  Divider,
  Modal
} from "@mui/material";
import { Box, height, width } from "@mui/system";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import * as React from "react";
import { useEffect, useRef, useState } from "react";
import "./style/discoverPage.css";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import CustomisedButton from "../../common/components/CustomisedButton";
import { callApi } from "../../common/api";
import DynamicCard from "./CardComponent";
import CustomizedSnackbars from "../alert/alert";
import RescheduleMeetingReason from "./RescheduleMeetingReason";
import { Avatar} from "@mui/material";
import Carousel from "react-elastic-carousel";
import LatestBlogs from "./LatestBlogs";
import axios from "axios";
// import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

export default function DiscoverPage(props) {
  const changeStatusDivView = () => {
    setKycStatusDiv(!kycStatusDiv);
  };
  const [fpVideo, setFpVideo] = React.useState('')
  const [openModal, setOpenModal] = React.useState(false)
  const [youtubeLink, setYoutubeLink] = React.useState([]);
  // const [companylogo, setCompanyLogo] = React.useState([]);
  const [data, setData] = React.useState({})
  const [blogData, setBlogData] = React.useState([]);
  const [productVideos, setProductVideos] = React.useState([]);
  const [itemsToShow, setItemsToShow] = React.useState(1)
  const [snackBarMsg, setSnackBarMsg] = React.useState({
    message: "",
    severity: "success",
    open: false,
  });
  const [isMobile, setIsMobile] = useState(false);
  const allData = JSON.parse(localStorage.getItem("AllData"))
  const mobile = allData?.admin?.mobile
  const adminName = allData?.admin?.name
  // const designation=allData?.admin?.
  const handleModal = () => {
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
  }
  const handleGetVideos = async () => {
    const whatFsFp = await axios.get(
      `${process.env.REACT_APP_STRAPI_API}/api/whatis-fps/1?populate=*`
    );
    setFpVideo(whatFsFp?.data?.data?.attributes)
  }
  const feUrl = process.env.REACT_APP_CMSFE_URL;
  async function handleGet() {
    try {
      const response = await callApi("get", "startup/StartupDealsInfo");
      const data = response.data.response.data;

      data.forEach((element) => {
        const regex =
          /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/;
        const match = element.url.match(regex);
        if (match && match[1]) {
          setYoutubeLink((prevLinks) => [...prevLinks, match[1]]);
        } else {
          setYoutubeLink((prevLinks) => [...prevLinks, "invalid url"]);
        }
      });
    } catch (err) {
      console.log(err);
    }
  }
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 768) {
        setItemsToShow(3);
      } else {
        setItemsToShow(1);
      }
    }
    window.addEventListener('resize', handleResize)
    // Initial call to handleResize to set initial value
    handleResize();
    return () => {

      window.removeEventListener('resize', handleResize)
    }
  }, [itemsToShow])

  const carouselStyles = {
    marginLeft: "-68px",
    width: "109%",
    height: '100%',
    ...(isMobile && { overflow: 'visible' })
  };

  const productDivStyles = {
    cursor: "pointer",
    width: "100%",
    ...(isMobile && { paddingRight: "20px" })
  };


  // const allStartups = async () => {
  //   try {
  //     const response = await callApi("get", `startup/allStartup`);
  //     console.log(
  //       response.data.response.data.equity,
  //       "this is all  startupsssssssssssssssss"
  //     );
  //     if (response.data.response.status) {
  //       const data = response.data.response.data.equity;
  //       data.forEach((element) => {
  //         if (element.companylogo != null) {
  //           const img = element.companylogo;
  //           const startupId = element.id;
  //           const dealid = element.dealid;
  //           setCompanyLogo((prevLinks) => [
  //             ...prevLinks,
  //             { img, startupId, dealid },
  //           ]);
  //         } else {
  //           const img =
  //             "https://upload.wikimedia.org/wikipedia/commons/b/bf/Incred-logo.jpg";
  //           const startupId = element.id;
  //           const dealid = element.dealid;
  //           setCompanyLogo((prevLinks) => [
  //             ...prevLinks,
  //             { img, startupId, dealid },
  //           ]);
  //         }
  //         console.log(element.companylogo, "element company logo");
  //       });

  //       setSnackBarMsg({
  //         message: response?.data?.response?.message,
  //         severity: "success",
  //         open: true,
  //       });
  //     }
  //   } catch (error) {
  //     if (error.response) {
  //       setSnackBarMsg({
  //         message: error.response.data.message,
  //         severity: "error",
  //         open: true,
  //       });
  //     }
  //   }
  // };

  const carouselRef = useRef(null);

  const handlePrevClick = () => {
    if (carouselRef.current && carouselRef.current.slidePrev) {
      carouselRef.current.slidePrev();
    }
  };

  const handleNextClick = () => {
    if (carouselRef.current && carouselRef.current.slideNext) {
      carouselRef.current.slideNext();
    }
  };

  const allStartups = async () => {
    try {
      const response = await callApi("get", `startup/allStartup`);
      if (response.data.response.status) {
        // setSnackBarMsg({
        //   message: response?.data?.response?.message,
        //   severity: "success",
        //   open: true
        // })
        return response.data.response.data
      }
    } catch (error) {
      if (error.response) {
        setSnackBarMsg({
          message: error.response.data.message,
          severity: "error",
          open: true,
        });

      }
    }

  }
  const handleClick = async (dealId, startUpId) => {
    localStorage.setItem("startUpId", JSON.stringify(startUpId));
    localStorage.setItem("dealId", JSON.stringify(dealId));
    let obj = {
      startupDealId: dealId,
      source: 0
    }
    try {
      const response = await callApi("post", "lead/createLead", obj)
      if (response.data.response.status) {
        window.location.href = "/startUpDetails"
      }
    } catch (err) {
      console.log(err)
    }
  }

  const handlePage = (href) => {
    window.location.href = `/allstartups?id=${href}`
  }
  async function handleGetData() {
    const BlogResponse = await axios.get(
      `${process.env.REACT_APP_STRAPI_API}/api/blogs-cards?populate=*`
    );
    const Blogdata = BlogResponse.data.data;
    Blogdata.sort(
      (a, b) =>
        new Date(b?.attributes?.createdAt) - new Date(a?.attributes?.createdAt)
    );
    setBlogData(Blogdata);
  }

  async function getProductVideo() {
    const videoRes = await axios.get(
      `${process.env.REACT_APP_STRAPI_API}/api/product-videos?populate=*`
    );
    const videData = videoRes.data.data;
    setProductVideos(videData);
  }

  const showBlog = (id) => {
    window.location.href = `${feUrl}/blogsPage?blogId=${id}`;
  };

  React.useEffect(() => {
    getProductVideo()
    handleGet();
    allStartups().then((key) => {
      setData(key)
    });
    handleGetData();
    handleGetVideos();
  }, []);

  const [kycStatusDiv, setKycStatusDiv] = React.useState(false);

  const [RegisterStep, setRegisterStep] = React.useState("")
  const [kycStatus, setKycStatus] = React.useState("")
  const [payment, setPayment] = React.useState(Boolean)
  async function getDetails() {
    try {
      const response = await callApi('get', 'userRegister')
      const data = response.data.response.data
      setRegisterStep(data?.registrationStep)
      setKycStatus(data?.kycStatus)

    } catch (error) {
      console.log(error, "error")
    }
  }

  const getPaymentData = async () => {
    const response = await callApi("get", "investor/getPayment")
    setPayment(response?.data?.response?.data?.isPaymentDone)
  }
  React.useEffect(() => {
    getDetails()
    getPaymentData()
  }, [])

  const youtubeVideoId = "z3LZbS6pM3M"
  const handleFaqs = () => {
    window.location.href = `${feUrl}/faq`
  }

  const handleClickFunct = () => {
    window.open(`https://wa.me/${mobile}`)
  }
  return (
    <>
      <Modal
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
          width: "70%",
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
      >

        <Box
          sx={{
            // backgroundColor: "white",
            // border:"1px solid red",
            borderRadius: "8px",
            boxShadow: 24,
            width: "100%",
            p: 4,
            height: '100%'
            // overflowY: "auto",
            // maxHeight: "80vh",
          }}
        >
          <iframe
            title="Video Modal"
            width="100%"
            height="400"
            src={fpVideo?.url ? `https://www.youtube.com/embed/${fpVideo?.url?.split('=')[1]}` : fpVideo?.video?.data?.attributes?.url}
            // src={`https://www.youtube.com/embed/${youtubeVideoId}`}
            frameborder="0"
            allow="autoplay; encrypted-media"
            allowfullscreen
          ></iframe>
        </Box>
      </Modal>
      <Box id="status-divMob">
        {/* <Box className="status-cardMob"> */}
        {/* <Box className="investment-cardsMob"> */}
        <Card className="cardCss"
          sx={{ height: "fit-content", width: "350px" }}
          style={{ backgroundColor: "#212121", color: "white" }}
        >
          {/* <CardContent
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <Box className="sidebox-areaMob">
              <Box className="sidebox-contentMob">
                <Box>
                  <Typography variant="body2" style={{ fontWeight: '600' }}>What is FP?</Typography>
                  <Typography variant="caption" style={{ fontSize: '0.875rem' }}>
                    Lorem ipsum dolor sit amet consectetur.
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="body2">
                    Play Video{" "}
                    <Button onClick={handleModal} style={{ minWidth: "fit-content" }}>
                      <PlayCircleOutlineIcon style={{ fill: "white", height: '20px' }} />
                    </Button>{" "}
                  </Typography>
                </Box>
              </Box>
              <img
                className="fpImage"
                src="/logo513.png"
                alt="logo"
              ></img>
            </Box>
          </CardContent> */}
        </Card>
        {/* </Box> */}
        {/* </Box> */}
      </Box>
      <Box className="container" id="main-contianer">
        <Box id="startup-info-div" style={{ width: "100%" }}>
          <Box className="section" sx={{ display: 'flex', flexWrap: 'wrap' }}>
            <Box className="section-heading">
              <Typography className="heading-text" variant="h5">
                Investment Options
              </Typography>
              <Typography className="heading-text" variant="caption">
                Lorem Ipsum is simply dummy text
              </Typography>
            </Box>
            <Box className="cards" style={{ gap: '24px', justifyContent: 'flex-start', flexWrap: "nowrap" }} >
              <Grid item xs={12} sm={6} md={4} className="investment-cards" style={{ width: "calc(100% / 3.2)" }}>
                <Card className="cardCss"
                  onClick={() => handlePage(1)}
                  sx={{ height: "250px", width: "225px", cursor: "pointer" }}
                  style={{ backgroundColor: "#212121", color: "white", borderRadius: "8px", width: "100%" }}
                >
                  <CardContent
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <img
                      src="/ic-investment.png"
                      alt="Image Preview 1"
                      style={{ width: "50px", height: "50px" }}
                    />
                    <br></br>
                    <Typography variant="subtitle2" component="h2" sx={{ fontSize: '20px' }} >
                      Start up Equity
                    </Typography>
                    <ul className="custom-bullet-list">
                      <li>
                        <Typography variant="caption" fontSize={12}>
                          One time payout
                        </Typography>
                      </li>
                    </ul>
                  </CardContent>
                </Card>
              </Grid>
              {/* <Grid item xs={12} sm={6} md={4} className="investment-cards" style={{ width: "calc(100% / 3.2)" }}>
                <Card className="cardCss"
                  onClick={() => handlePage(2)}
                  sx={{ height: "250px", width: "225px", cursor: "pointer" }}
                  style={{ backgroundColor: "#212121", color: "white", borderRadius: "8px", width: "100%" }}
                >
                  <CardContent
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <img
                      src="/ic-investment.png"
                      alt="Image Preview 1"
                      style={{ width: "50px", height: "50px" }}
                    />
                    <br></br>

                    <Typography variant="subtitle2" component="h2" sx={{ fontSize: '20px' }} >
                      Debt
                    </Typography>
                    <ul className="custom-bullet-list">
                      <li>
                        <Typography variant="caption" fontSize={12}>
                          Multiple Product offerings with Flexible tenor
                        </Typography>
                      </li>
                      <li>
                        <Typography variant="caption" fontSize={12}>
                          Monthly/ quarterly/ semi annually payouts
                        </Typography>
                      </li>
                    </ul>
                  </CardContent>
                </Card>
              </Grid> */}
              <Grid item xs={12} sm={6} md={4} className="investment-cards" style={{ width: "calc(100% / 3.2)" }}>
                <Card className="cardCss"
                  onClick={() => handlePage(3)}
                  sx={{ height: "250px", width: "225px", cursor: "pointer" }}
                  style={{ backgroundColor: "#212121", color: "white", borderRadius: "8px", width: "100%" }}
                >
                  <CardContent
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <img
                      src="/ic-investment.png"
                      alt="Image Preview 1"
                      style={{ width: "50px", height: "50px" }}
                    />
                    <br></br>

                    <Typography variant="subtitle2" component="h2" sx={{ fontSize: '20px' }} >
                      Mergers & Acquisition
                    </Typography>
                    <ul className="custom-bullet-list">
                      <li>
                        <Typography variant="caption" fontSize={12}>
                          Explore opportunities to build synergies
                        </Typography>
                      </li>
                    </ul>
                  </CardContent>
                </Card>
              </Grid>
            </Box>
          </Box>
          <Box className="section" sx={{ width: '100%' }} >
            <Box className="section-heading">
              <Typography className="heading-text" variant="h5">
                Live Deals
              </Typography>
              <Typography className="heading-text" variant="caption">
                Lorem Ipsum is simply dummy text
              </Typography>
            </Box>
            <Box className="liveDealsSwiper" sx={{ width: "100%", height: '100%', display: 'flex', gap: '30px' }}>
              <Carousel className="carouselLiveDeal" style={{ width: "100%", height: '100%', }} itemsToShow={itemsToShow} showIndicators={true} ref={carouselRef}>
                {data && data["Equity"]?.map((data) => (
                  <>
                    <Grid className="outerBox" sx={{ width: '100%', display: 'flex', gap: '30px' }}>
                      <DynamicCard
                        imageData={data.companylogo}
                        dealid={data.dealid}
                        startUpId={data.id}
                        onButtonClick={handleClick}
                        resource={data.resource?.basicDetails}
                      />
                    </Grid>
                  </>
                ))}
                {data && data["Debt"]?.map((data) => (
                  <>
                    <Grid className="outerBox">
                      <DynamicCard
                        imageData={data.companylogo}
                        dealid={data.dealid}
                        startUpId={data.id}
                        onButtonClick={handleClick}
                        resource={data.resource?.basicDetails}
                      />
                    </Grid>
                  </>
                ))}
                {data && data["Mergers and Acquisition"]?.map((data) => (
                  <>
                    <Grid className="outerBox">
                      <DynamicCard
                        imageData={data.companylogo}
                        dealid={data.dealid}
                        startUpId={data.id}
                        onButtonClick={handleClick}
                        resource={data.resource?.basicDetails}
                      />
                    </Grid>
                  </>
                ))}
              </Carousel>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: '0px' }}>
              <button
                className="rec-arrow-left"
                onClick={handlePrevClick}
                style={{ background: 'none', border: 'none' }}
              >
                {/* Add left arrow icon or text */}
                <PlayCircleOutlineIcon style={{ color: 'white', width: '30px', height: '30px', transform: 'rotate(180deg)' }} />
              </button>
              <button
                className="rec-arrow-right"
                onClick={handleNextClick}
                style={{ background: 'none', border: 'none' }}
              >
                {/* Add right arrow icon or text */}
                <PlayCircleOutlineIcon style={{ color: 'white', width: '30px', height: '30px' }} />
              </button>
            </Box>
          </Box>

          <Box sx={{ maxWidth: "100%" }} className="section">
            <Box className="section-heading">
              <Typography className="heading-text" variant="h5">
                Product Video
              </Typography>
              <Typography className="heading-text" variant="caption">
                Lorem Ipsum is simply dummy text
              </Typography>
            </Box>
            {itemsToShow == 3 ?
              <Box className="productVideosBox"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "24px"
                }}
              >
                {productVideos?.map((data, index) =>
                  index < 3 ? (

                    <div style={{ cursor: "pointer" }} onClick={handleModal}>
                      <Box key={index} style={{ width: "fit-content" }}>
                        <Grid item xs={12}>
                          <Card className="cardCss"
                            sx={{ maxHeight: "700px", width: "225px" }}
                            style={{ backgroundColor: "#212121", color: "white", borderRadius: "8px" }}
                          >
                            <CardContent
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                height: "240px",
                                position: "relative"
                                // padding:"unset"
                              }}
                            >
                              <iframe
                                style={{ pointerEvents: "none" }}
                                width="auto"
                                height="500px"
                                src={data?.attributes?.url ? `https://www.youtube.com/embed/${data?.attributes?.url.split('=')[1]}` : data?.attributes?.video?.data?.attributes?.url}
                                // src={`https://www.youtube.com/embed/${youtubeVideoId}`}
                                frameborder="3"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowfullscreen
                              ></iframe>
                              <div
                                onClick={handleModal}
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  background: "transparent",
                                }}
                              ></div>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Box>
                    </div>
                  ) : (
                    <></>
                  ))}
              </Box> : <Box className="productVideoMainBox"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                  gap: "24px",
                  width: "100%"
                }}
              >
                {/* <Carousel className="carouselLiveDeal" style={{ marginLeft: "-68px", width: "109%", height: '100%' }} itemsToShow={itemsToShow} showIndicators={true}>
                  {productVideos?.map((data, index) =>
                    // index < 3 ? (

                    <div className="productDiv" style={{ cursor: "pointer", width: "100%" }} onClick={handleModal}>
                      <Box key={index} style={{ width: "100%" }}>
                        <Grid item xs={12}>
                          <Card className="productVideoCard"
                            sx={{ maxHeight: "700px", width: "279px" }}
                            style={{ backgroundColor: "#212121", color: "white" }}
                          >
                            <CardContent
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                height: "240px",
                                position: "relative"
                                // padding:"unset"
                              }}
                            >
                              <iframe
                                style={{ pointerEvents: "none" }}
                                width="auto"
                                height="500px"
                                src={data?.attributes?.url ? `https://www.youtube.com/embed/${data?.attributes?.url.split('=')[1]}` : data?.attributes?.video?.data?.attributes?.url}
                                // src={`https://www.youtube.com/embed/${youtubeVideoId}`}
                                frameborder="3"
                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                allowfullscreen
                              ></iframe>
                              <div
                                onClick={handleModal}
                                style={{
                                  position: "absolute",
                                  top: 0,
                                  left: 0,
                                  width: "100%",
                                  height: "100%",
                                  background: "transparent",
                                }}
                              ></div>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Box>
                    </div>
                    // ) : (
                    // <></>
                  )}
                </Carousel> */}

<Carousel 
  className="carouselLiveDeal" 
  style={carouselStyles}
  itemsToShow={isMobile ? 1 : itemsToShow} // Use your original itemsToShow for desktop
  itemPadding={isMobile ? [0, 10] : [0, 0]}
  showIndicators={true}
  enableSwipe={isMobile}
  enableMouseSwipe={isMobile}
  showArrows={!isMobile}
>
  {productVideos?.map((data, index) => (
    <div 
      key={index}
      className="productDiv" 
      style={productDivStyles} 
      onClick={handleModal}
    >
      <Box style={{ width: "100%" }}>
        <Grid item xs={12}>
          <Card 
            className="productVideoCard"
            sx={{ 
              maxHeight: "700px", 
              width: "279px",
              backgroundColor: "#212121", 
              color: "white" 
            }}
          >
            <CardContent
              style={{
                display: "flex",
                flexDirection: "column",
                height: "240px",
                position: "relative"
              }}
            >
              <iframe
                style={{ pointerEvents: "none" }}
                width="auto"
                height="500px"
                src={data?.attributes?.url ? `https://www.youtube.com/embed/${data?.attributes?.url.split('=')[1]}` : data?.attributes?.video?.data?.attributes?.url}
                frameBorder="3"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
              <div
                onClick={handleModal}
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  background: "transparent",
                }}
              ></div>
            </CardContent>
          </Card>
        </Grid>
      </Box>
    </div>
  ))}
</Carousel>
              </Box>}
          </Box>

          <Box sx={{ maxWidth: "100%" }} className="section">
            <Box className="section-heading">
              <Typography className="heading-text" variant="h5">
                Latest Blogs
              </Typography>

              <Typography className="heading-text" variant="caption">
                Lorem Ipsum is simply dummy text
              </Typography>
            </Box>
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: "24px", maxWidth: "100%" }}>
              {blogData.map((data, index) =>
                index < 3 ? (
                  <>
                    <Box sx={{ display: "inline-block", width: "calc(100% / 3.2)" }} className="cards latestBlogCards">
                      <LatestBlogs blogs={blogData[2] ? 3 : 2} data={data} showBlog={showBlog} />
                    </Box>

                  </>
                ) : (
                  <></>
                )
              )}
            </Box>
          </Box>
          {/* <Box className="faqsMobView"> */}
          <Box className="section mt-6">
            <Box className="section-heading">
              <Typography className="heading-text" variant="h5">
                FAQ'S
              </Typography>
              <Typography className="heading-text" variant="caption">
                Lorem Ipsum is simply dummy text
              </Typography>
            </Box>
            <Box className="cards" style={{ justifyContent: "flex-start", gap: "24px" }}>
              <Grid item xs={12} sm={6} md={4} className="investment-buttons" style={{ width: "calc(100% / 2 - 24px)" }}>
                <Button className="faq-buttons" onClick={handleFaqs}>
                  <Typography variant="h5">Start Up Equity</Typography>
                  <ArrowForwardIosIcon />
                </Button>
                <Button className="faq-buttons" onClick={handleFaqs}>
                  <Typography variant="h5">Debt</Typography>
                  <ArrowForwardIosIcon />
                </Button>
              </Grid>
              <Grid item xs={12} sm={6} md={4} className="investment-buttons" style={{ width: "calc(100% / 2 - 24px)" }}>
                <Button className="faq-buttons" onClick={handleFaqs}>
                  <Typography variant="h5">Mergers & Acquisitions</Typography>
                  <ArrowForwardIosIcon />
                </Button>
                <Button className="faq-buttons" onClick={handleFaqs}>
                  <Typography variant="h5">General</Typography>
                  <ArrowForwardIosIcon />
                </Button>
              </Grid>
            </Box>
          </Box>
          {/* </Box> */}
        </Box>
        <Box id="status-div">
          <Box className="status-card">
            <Box className="investment-cards">
              <Card className="cardComponent"
                sx={{ height: "fit-content", width: "300px" }}
                style={{ backgroundColor: "#212121", color: "white", borderRadius: "8px" }}
              >
                <CardContent
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "20px",
                  }}
                >
                  <Box className="sidebox-area">
                    <Box className="sidebox-content">
                      <Box>
                        <Typography variant="body2" style={{ fontWeight: '600' }}>What is FP?</Typography>
                        <Typography variant="caption" style={{ fontSize: '0.875rem' }}>
                          Lorem ipsum dolor sit amet consectetur.
                        </Typography>
                      </Box>
                      <Box>
                        <Typography variant="body2">
                          Play Video{" "}
                          <Button onClick={handleModal} style={{ minWidth: "fit-content" }}>
                            <PlayCircleOutlineIcon style={{ fill: "white", height: '20px' }} />
                          </Button>{" "}
                        </Typography>
                      </Box>
                    </Box>
                    <img
                      className="fpImage"
                      src="/logo513.png"
                      alt="logo"
                    ></img>
                  </Box>
                  <Box className="sidebox-area">
                    <Box className="sidebox-content">
                      <Box className="steps-close">
                        <Typography variant="body1">Steps To Go</Typography>
                        {!kycStatusDiv ? (
                          <Typography variant="body1">
                            Open
                            <Button onClick={changeStatusDivView} style={{ minWidth: "fit-content", paddingRight: "0" }}>
                              <KeyboardArrowDownIcon style={{ fill: "white" }} />
                            </Button>
                          </Typography>
                        ) : (
                          <Typography variant="body1">
                            Close
                            <Button onClick={changeStatusDivView} style={{ minWidth: "fit-content", paddingRight: "0" }}>
                              <KeyboardArrowUpIcon style={{ fill: "white" }} />
                            </Button>
                          </Typography>
                        )}
                      </Box>

                      <Box className="user-status">
                        <div style={{ backgroundColor: RegisterStep == 3 ? "green" : "black" }} className="status-number">1</div>
                        <div style={{ backgroundColor: kycStatus == 1 ? "green" : "" }} id="status-bar-1"></div>
                        <div style={{ backgroundColor: kycStatus == 1 ? "green" : "black" }} className="status-number">2</div>
                        <div style={{ backgroundColor: payment ? "green" : "" }} id="status-bar-1"></div>
                        <div style={{ backgroundColor: payment ? "green" : "" }} className="status-number">3</div>
                      </Box>

                      <Typography variant="body2">
                        Lorem ipsum dolor sit amet consectetur. Vehicula diam
                        mauris imperdiet placerat id lacus porta auctor quam.
                      </Typography>
                      <hr style={{ width: "100%", marginBottom: '0' }}></hr>
                      <Box className="open-status">
                        {kycStatusDiv ? (
                          <Box style={{ marginTop: '1rem' }}>
                            <Box sx={{ display: "flex", textAlign: "center", alignItems: "center" }}>
                              <div style={{ backgroundColor: RegisterStep == 3 ? "green" : "" }} className="status-number">1</div>
                              <Typography sx={{ paddingLeft: "25px", lineHeight: "initial" }}>
                                Sign up
                              </Typography>
                            </Box>
                            <div style={{ backgroundColor: kycStatus == 1 ? "green" : "" }} id="status-bar"></div>
                            <Box sx={{ display: "flex", textAlign: "center" }}>
                              <div style={{ backgroundColor: kycStatus == 1 ? "green" : "" }} className="status-number">2</div>
                              <Typography sx={{ paddingLeft: "25px" }}>
                                Complete KYC
                              </Typography>
                            </Box>
                            <div style={{ backgroundColor: payment ? "green" : "" }} id="status-bar"></div>
                            <Box sx={{ display: "flex", textAlign: "center" }}>
                              <div style={{ backgroundColor: payment ? "green" : "" }} className="status-number">3</div>
                              <Typography sx={{ paddingLeft: "25px" }}>
                                Make your first investment
                              </Typography>
                            </Box>
                          </Box>
                        ) : (
                          <></>
                        )}
                      </Box>
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          </Box>
          {/* <Box className="status-card">
            <Box className="investment-cards">
              <Card className="cardCss"
                sx={{ height: "fit-content", width: "300px" }}
                style={{ backgroundColor: "#212121", color: "white", borderRadius: "8px" }}
              >
                <CardContent
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "14px",
                  }}
                >
                  <Box>
                    <Typography variant="h6">Need to help ?</Typography>
                    <Typography variant="body2">
                      Lorem ipsum dolor sit amet consectetur. Elementum in sem
                      mattis odio habitasse massa cursus.
                    </Typography>
                  </Box>
                  <Box className="sidebox-area" sx={{ display: 'flex', justifyContent: 'flex-start !important' }}>
                    <h1>Hello</h1>
                    <button style={{ backgroundColor: "inherit", border: "none", cursor: "pointer" }} ><Avatar style={{ height: '50px', width: '50px' }}></Avatar></button>
                    <Box sx={{ padding: '10px' }}>
                      <Typography sx={{ fontSize: '20px', fontWeight: '500' }}>{adminName} </Typography>
                      <Typography sx={{ fontStyle: 'normal', color: 'grey' }}>Designation</Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      gap: "15px",
                      justifyContent: "center",
                      alignItems: 'center'
                    }}
                  >
                    <CustomisedButton
                      children="Call Now"
                      variant="outlined"
                    ></CustomisedButton>
                    <CustomisedButton
                      children="Start a Chat"
                      variant="contained"
                      handleClick={handleClickFunct}
                    ></CustomisedButton>
                  </Box>
                </CardContent>
              </Card>
            </Box>
          </Box> */}
          <Box className="faqsBox">
            <Box className="section mt-5">
              <Box className="section-heading">
                <Typography className="heading-text" variant="h5">
                  FAQ'S
                </Typography>
                <Typography className="heading-text" variant="caption">
                  Lorem Ipsum is simply dummy text
                </Typography>
              </Box>
              <Box className="cards">
                <Grid item xs={12} sm={6} md={4} className="investment-buttons">
                  <Button className="faq-buttons" onClick={handleFaqs}>
                    <Typography variant="h5">Start Up Equity</Typography>
                    <ArrowForwardIosIcon />
                  </Button>
                  <Button className="faq-buttons" onClick={handleFaqs}>
                    <Typography variant="h5">Debt</Typography>
                    <ArrowForwardIosIcon />
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6} md={4} className="investment-buttons">
                  <Button className="faq-buttons" onClick={handleFaqs}>
                    <Typography variant="h5">Mergers & Acquisitions</Typography>
                    <ArrowForwardIosIcon />
                  </Button>
                  <Button className="faq-buttons" onClick={handleFaqs}>
                    <Typography variant="h5">General</Typography>
                    <ArrowForwardIosIcon />
                  </Button>
                </Grid>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <CustomizedSnackbars msgData={snackBarMsg} setMsgData={setSnackBarMsg} />
    </>
  );
}
